/* eslint-disable */
import {
  fully_invested_actions,
  defaultWhaleTraderCriteria,
  marketTiming
} from '@/data/whale_trader_constants'
import cloneDeep from 'lodash/cloneDeep'

export default {

  SET_GROUPS (state, groups) {
    function compare( a, b ) {
      if ( a.name < b.name ){
        return -1;
      }
      if ( a.name > b.name ){
        return 1;
      }
      return 0;
    }
    groups.forEach(bt => {
      bt.filers.sort(compare)
    })
    state.groups = groups
  },

  SET_WATCHLISTS (state, groups) {
    function compare( a, b ) {
      if ( a.name < b.name ){
        return -1;
      }
      if ( a.name > b.name ){
        return 1;
      }
      return 0;
    }
    if (!groups)
      return;
      if (groups=="You are not logged in")
        return;
    groups.forEach(bt => {
      bt.stocks.sort(compare)
    })
    state.watchlists = groups
  },


  SET_EMAIL_ALERTS (state, alerts) {
    state.emailAlerts = alerts
  },
  SET_MOST_ACTIVE_STOCKS (state, alerts) {
    state.active_stocks = alerts
  },
  SET_MOST_ACTIVE_FILERS (state, alerts) {
    state.active_filers = alerts
  },
  SET_TRENDING_STOCKS (state, alerts) {
    state.trending_stocks = alerts
  },
  SET_TRENDING_FILERS (state, alerts) {
    state.trending_filers = alerts
  },

  SET_BACKTESTS (state, backtests) {
    function extractMonthlyPerformance (bt, data) {
      if (!data || data.length==0){
        return;
      }
      bt.monthly_performance = []
      let whale = data[0]
      let sp = data[1]

      for (let k = 0; k < whale.values.length; k++) {
        let d = whale.values[k]
        let e = sp.values[k]
        bt.monthly_performance.push({
          month: d.x,
          whale: d.z,
          sp: e.z,
          diff: d.z - e.z
        })
      }
    }

    backtests.forEach(bt => {
      extractMonthlyPerformance(bt, JSON.parse(bt.chart_data))
      bt.last_portfolio = JSON.parse(bt.last_portfolio)
      bt.criteria = JSON.parse(bt.criteria_json)
    })

    state.trackedBacktests = backtests
  },

  SET_USER (state, user) {
    if (!user) return

    state.user = user
    if (user.id && user.id>0)
      state.isLoggedIn=true
    const today = new Date()
    const yesterday = today.setDate(today.getDate() - 1)

    if (user.subscription_limit && (user.subscription_limit.allowed_team_members > 0 || user.primary_account)) {
      state.isTeamMember = true
    }

    if (user.user_subscription) {
      let date = new Date(user.user_subscription.subscription_end_date)
      state.isSubscriber = date >= yesterday
    }

    if (state.isSubscriber) {
      state.limit = 50
      if (user.user_subscription.subscription_type_id === 2) {
        state.isProSubscriber = true
      } else if (user.user_subscription.subscription_type_id === 3) {
        state.isEnterpriseSubscriber = true
        state.limit = 9999
      }
      if (user.subscription_limit) {
        state.limit = user.subscription_limit.report_filer_limit
      }
    }

    if (user.primary_account) {
      let date = new Date(user.primary_account.user_subscription.subscription_end_date)

      state.isSubscriber = date >= yesterday

      if (state.isSubscriber) {
        if (user.primary_account.subscription_limit) {
          state.limit = user.primary_account.subscription_limit.report_filer_limit
        }
        if (user.primary_account.user_subscription.subscription_type_id === 2) {
          state.isProSubscriber = true
        } else if (user.primary_account.user_subscription.subscription_type_id === 3) {
          state.isEnterpriseSubscriber = true
          state.limit = 9999
        }
      } else {
        state.limit = 5
        state.isEnterpriseSubscriber = false
        state.isProSubscriber = false
      }
    }
    user.limit=state.limit
  },

  SET_INSIDER_ALERTS (state, insiderAlerts) {
    insiderAlerts.forEach(alert => {
      let criteria = JSON.parse(alert.criteria_body)
      let cluster = criteria.alert_criteria.entry_cluster_buy_criteria

      let transactionType = cluster.transaction_type === 1
        ? 'All Buy Transactions'
        : 'Open Market Purchases'

      let dateRange =
        cluster.date_range === 0 ? 'Past Day'
        : cluster.date_range === 1 ? 'Past 3 Days'
        : cluster.date_range === 2 ? 'Past 7 Days'
        : cluster.date_range === 3 ? 'Past Month'
        : cluster.date_range === 4 ? 'Past 3 Months'
        : 'Past 2 Weeks'

      let ownerTypes = (() => {
        if (!cluster.owner_types.length || cluster.owner_types.length === 5) {
          return ['All']
        } else {
          return cluster.owner_types
            .map(type => (
              type === 1 ? '>10% Owner'
              : type === 2 ? 'Director'
              : type === 3 ? 'Officer'
              : type === 4 ? 'C-Level Officer'
              : 'Other Owner'
            ))
        }
      })()

      alert.strategy = {
        transactionType,
        dateRange,
        ownerTypes
      }
    })

    state.insiderAlerts = insiderAlerts
  },

  SET_TRADING_MODELS (state, params) {
    var tradingModels=params.tradingModels;
    var rootState=params.rootState;


    state.tradingModels= tradingModels;
  },
  SET_SHARED_MODELS (state, params) {
    var sharedModels=params.sharedModels;
    var rootState=params.rootState;


    state.sharedModels= sharedModels;
  },
  SET_SCREENS (state, params) {
    var screens=params.screens;
    var rootState=params.rootState;


    state.screens= screens;
  }


}
